import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const volumeCommitmentsTypesAdapter = getAdapter({ idFieldName: 'value' });

const volumeCommitmentsTypesSlice = createSlice({
  name: 'volumeCommitmentsTypes',
  initialState: volumeCommitmentsTypesAdapter.getInitialState(),
  reducers: {
    setVolumeCommitmentsTypes: (state, { payload: { volumeCommitmentsTypes } }) => {
      volumeCommitmentsTypesAdapter.setAll(state, volumeCommitmentsTypes);
    },
  },
});

const selectors = volumeCommitmentsTypesAdapter.getSelectors(({ volumeCommitmentsTypes }) => volumeCommitmentsTypes);

export const getVolumeCommitmentsTypes = (state) => selectors.selectAll(state);

export const {
  setVolumeCommitmentsTypes,
} = volumeCommitmentsTypesSlice.actions;

export default volumeCommitmentsTypesSlice.reducer;
